import { assets, icons } from 'common';
import { CopyIcon, DepositPanelCSS } from './DepositPanelCSS.styled';
import { useTransak } from 'hooks/yoloWallet/useTransak';
import { useEffect, useRef, useState } from 'react';
import { useUser } from 'hooks/user/useUser';
import { doCopy } from 'utils';

export const DepositPanel = () => {
  const inputRef = useRef();
  const [hasCopied, setHasCopied] = useState(false);
  const { account, isProxy } = useUser('wallet');

  const { initTransak } = useTransak();
  const [fiatInputAmount, setFiatInputAmount] = useState('');

  const onDeposit = (e) => {
    // initTransak(fiatInputAmount)
    e.preventDefault();
    initTransak();
  };

  useEffect(() => {
    if (hasCopied) {
      const timer = setTimeout(() => {
        setHasCopied(false);
        inputRef.current.blur();
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [hasCopied]);

  const onCopy = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    const copied = await doCopy(account);

    if (copied) setHasCopied(true);
  };

  // const onInputChange = (event) => {
  //   const value = event.target.value.replace(',', '.')
  //   if (!value) {
  //     setFiatInputAmount('')
  //     return
  //   }

  //   const amountRegEx = /^(\d+)(\.)?(\d{0,2})$/
  //   if (amountRegEx.test(value)) setFiatInputAmount(value)
  // }
  return (
    <DepositPanelCSS>
      <div className='deposit_sections_wrapper'>
        <div className='wallet_tabs_panel' id='deposit_panel'>
          {/* DEPOSIT PAD */}
          <div className='tabbed_section'>
            <div className='panel_title'>
              <div className='panel_icons'>
                <img alt='img' src={assets.usdc_icon} />
                <img alt='img' src={assets.usd_icon} />
                <img alt='img' src={assets.euro_icon} />
              </div>
              DEPOSIT USDC
            </div>
            <div className='panel_ui_type'>VIA CREDIT/DEBIT CARD</div>

            <div className='panel_desc'>
              Use your credit/debit card and connect to Transak to deposit USDC.
              <img alt='img' src={icons.credit_card_icon} className='cc' />
            </div>
            <form>
              <button onClick={onDeposit}>Deposit now</button>
            </form>
          </div>

          {/* POLYGON PAD */}
          <div className='tabbed_section polygon'>
            <div className='panel_title'>
              <div className='panel_icons'>
                <img alt='img' src={assets.usdc_icon} />
              </div>
              DEPOSIT USDC
            </div>
            <div className='panel_ui_type'>VIA POLYGON NETWORK ONLY</div>
            <div className='panel_desc'>
              Deposit funds from an Exchange via Polygon Network
            </div>
            <form className='polygon'>
              <div className='withdraw_assistance'>
                Copy the address and paste it into the field at the Polygon
                exchange of your choice.
              </div>
              <div className='label_row'>
                <label>Send USDC to</label>
              </div>
              <div
                ref={inputRef}
                className='mm_address_bottom'
                onClick={onCopy}
              >
                <div className='wallet_id_full'>
                  <span>{account}</span>
                  <CopyIcon
                    collection='general'
                    name={hasCopied ? 'tick' : 'copy'}
                    masking
                  />
                </div>
              </div>
            </form>
          </div>

          {/* ETHEREUM PAD */}
          <div className='tabbed_section ethereum'>
            <div className='panel_title'>
              <div className='panel_icons'>
                <img alt='img' src={assets.eth_icon} />
                <img alt='img' src={assets.usdt_icon} />
                <img alt='img' src={assets.usdc_icon} />
              </div>
              DEPOSIT ETH, USDT, &amp; USDC
            </div>
            <div className='panel_ui_type'>VIA ETHEREUM NETWORK ONLY</div>
            <div className='panel_desc'>
              Deposit funds from an Exchange via Ethereum Network
              <div className='minimum_deposit'>
                {' '}
                Minimum deposit : 0.006 ETH{' '}
              </div>
            </div>
            <form className='polygon'>
              <div className='withdraw_assistance'>
                Copy the address and paste it into the field at the Ethereum
                exchange of your choice.
              </div>
              <div className='label_row'>
                <label>Send ETH, USDT, or USDC to</label>
              </div>
              <div
                ref={inputRef}
                className='mm_address_bottom'
                onClick={onCopy}
              >
                <div className='wallet_id_full'>
                  <span>{account}</span>
                  <CopyIcon
                    collection='general'
                    name={hasCopied ? 'tick' : 'copy'}
                    masking
                  />
                </div>
                <div className='information_message'>
                  Ethereum deposits may take 15-30 minutes to reflect in your
                  balance
                </div>
              </div>
            </form>
          </div>

          {/* <!-- WITHDRAW HISTORY --> */}

          {/* <div className="tabbed_section deposit_history">
									
								 </div>									  */}
        </div>
      </div>
    </DepositPanelCSS>
  );
};
